import React, { useState, useCallback } from "react";
import { BlockEditProps } from "@wordpress/blocks";
import { InspectorControls, useBlockProps } from "@wordpress/block-editor";
import type { BlockAttributes } from "./block.json";
import { PanelBody, PanelRow, SelectControl } from "@wordpress/components";
import { useSelect, withSelect } from "@wordpress/data";
import { Placeholder } from "@wordpress/components";
import { format } from "date-fns";
interface News {
  id: number;
  title: {
    rendered: string;
  };
  meta: {
    subline: string;
    description: string;
  };
  featured_media: number;
}

export default function NewsEditor(
  props: BlockEditProps<BlockAttributes>
): JSX.Element {
  const blockProps = useBlockProps({ className: "" });

  const [selectedNewsId, setSelectedNewsId] = useState<string[]>([]);

  const news = useSelect((select: any) => {
    return select("core").getEntityRecords("postType", "post", {
      per_page: -1,
    });
  }, []);

  const handleSelectChange = useCallback(
    (newsValues: string[]) => {
      setSelectedNewsId(newsValues);
    },
    [setSelectedNewsId]
  );

  if (news) {
    Object.entries(news as News).forEach(([key, newsItem]) => {
      if (selectedNewsId[0] === newsItem.id.toString()) {
        props.setAttributes({
          imageId: newsItem.featured_media,
          imageUrl: newsItem.meta.thumbnailUrl.toString(),
          imageAlt: newsItem.title.rendered,
          title: newsItem.title.rendered,
          content: newsItem.excerpt.raw,
          linkUrl: newsItem.link,
          postDate: format(new Date(newsItem.date), "dd.MM.yyyy"),
        });
      }
    });
  }

  return (
    <>
      <InspectorControls key="advanced">
        <PanelBody title="News" initialOpen={false}>
          <PanelRow>
            {news && (
              <SelectControl
                multiple={true}
                className="news-select"
                onChange={handleSelectChange}
                options={Array.from(news).map((newsItem: any) => ({
                  value: newsItem.id,
                  label: newsItem.title.rendered,
                  className:
                    selectedNewsId[0] === newsItem.id.toString() ? true : false,
                }))}
              />
            )}
          </PanelRow>
        </PanelBody>
      </InspectorControls>
      <div {...blockProps}>
        <div className="news-card">
          {props.attributes.imageUrl ? (
            <img
              src={props.attributes.imageUrl}
              alt={props.attributes.imageAlt}
            />
          ) : (
            <Placeholder
              withIllustration={true}
              className="img-placeholder"
              label="Bild auswählen"
            />
          )}
          <div className="card-content">
            <h3 className="pure pt-5">{props.attributes.title}</h3>
            <p className="blue-30">{props.attributes.content}</p>
          </div>
        </div>
      </div>
    </>
  );
}
